/**
 * @generated SignedSource<<3f9c9d9fbf7f22556ddf7d8ed247d65c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditMessageDefinitionPageForm_MessageDefinitionPageFragment$data = {
  readonly id: string;
  readonly image: {
    readonly fileType: string;
    readonly id: string;
    readonly name: string;
    readonly uploadDateTime: string;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly internalTitle: string;
  readonly " $fragmentType": "EditMessageDefinitionPageForm_MessageDefinitionPageFragment";
};
export type EditMessageDefinitionPageForm_MessageDefinitionPageFragment$key = {
  readonly " $data"?: EditMessageDefinitionPageForm_MessageDefinitionPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditMessageDefinitionPageForm_MessageDefinitionPageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditMessageDefinitionPageForm_MessageDefinitionPageFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileType",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadDateTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MessageDefinitionPage",
  "abstractKey": null
};
})();

(node as any).hash = "8b16675260857eeff2f214d18ca9c4f7";

export default node;
